export const AZ = {
  "nav.services": "Xidmətlər",
  "nav.pricing": "Qiymətlər",
  "nav.request_viewing": "Baxış istəyi",
  "nav.why_us": "Niyə biz",
  "nav.faq": "Suallar",
  "nav.contact": "Əlaqə",
  "lang.Turkish": "Türk dili",
  "lang.English": "İngilis dili",
  "lang.Azerbaijani": "Azərbaycan dili",
  "lang.Polish": "Polyak dili",
  "proc.step": "ADDIM",
  "meta.title": "Unity Real Estate — Varşavada mənzil, ev və köçmə dəstəyi",
  "nav.owner": "Ev sahibisiniz?",
  "common.whatsapp": "WhatsApp",
  "common.call": "Zəng et",
  "hero.location": "Varşava · Polşa",
  "hero.live": "1 saat ərzində cavab",
  "hero.owner_cta": "Ev sahibisiniz? Kirayəçi tapaq",
  "hero.title.1": "Varşavada yeni eviniz —",
  "hero.title.2": "stressiz və narahatçılıqsız.",
  "hero.subtitle": "İstər Varşavaya ilk dəfə köçürsünüz, istər artıq buradasınız və mənzil dəyişmək istəyirsiniz, istərsə də icarənizi vaxtından əvvəl bitirmək üçün yerinizə kirayəçi axtarırsınız — mənzili də, sənədləri də, polyak dilini də biz həll edirik. Özü də öz dilinizdə.",
  "hero.cta_whatsapp": "WhatsApp-da yazın",
  "hero.trust_stars": "300+ ailənin etibar etdiyi ad · Türk və azərbaycanlı müştərilər hər gün bizimlədir",
  "hero.stats.families": "ailəyə kömək etdik",
  "hero.stats.time_label": "Açara qədər orta müddət",
  "hero.stats.time_value": "5 gün",
  "hero.stats.docs_label": "Sənəd dəstəyi",
  "hero.stats.docs_value": "Daxildir",
  "hero.stats.lang_label": "Danışılan dil",
  "hero.stats.districts_label": "Xidmət rayonları",
  "hero.stats.districts_value": "Śródmieście, Mokotów, Wola +12",
  "hero.stats.quote": "\"PESEL, icarə müqaviləsi və köçmə işlərimi bir həftəyə həll etdilər.\"",
  "hero.stats.quote_author": "— Ayşe, İstanbul → Varşava",
  "hero.scroll": "sürüşdür",
  "aud.eyebrow": "Kimlərə kömək edirik",
  "aud.title.1": "Üç fərqli yol,",
  "aud.title.2": "bir etibarlı komanda.",
  "aud.blurb": "Polşadakı ilk gününüzdən açarı təhvil verdiyiniz günə qədər Varşavada mənzillə bağlı hər işdə yanınızdayıq.",
  "aud.new.title": "Varşavaya köçürəm",
  "aud.new.text": "Polşaya yeni gəlmisiniz və mənzil, PESEL, icarə müqaviləsi və arada olan hər şeyə ehtiyacınız var? Əvvəldən sona qədər yanınızdayıq.",
  "aud.new.msg": "Salam! Varşavaya köçürəm, mənzil tapmaq və sənədlərlə bağlı köməyə ehtiyacım var.",
  "aud.change.title": "Artıq Varşavadasınız?",
  "aud.change.text": "Burada yaşayırsınız və mənzil dəyişmək istəyirsiniz — daha yaxşı yer, daha böyük ev və ya daha sərfəli kirayə — növbətini biz tapaq.",
  "aud.change.msg": "Salam! Artıq Varşavadayam, yeni mənzil tapmağıma kömək edə bilərsiniz?",
  "aud.replace.title": "Yerinizə kirayəçi axtarırsınız?",
  "aud.replace.text": "Varşavadan tez ayrılırsınız və icarənizi təhvil alacaq birini axtarırsınız? Yerinizə kirayəçi tapır, ev sahibinizlə təhvil prosesini biz idarə edirik.",
  "aud.replace.msg": "Salam! Varşavadakı icarəmi təhvil alacaq kirayəçi tapmalıyam, kömək edə bilərsiniz?",
  "rv.eyebrow": "Baxış istəyi",
  "rv.title.1": "Nə istədiyinizi deyin —",
  "rv.title.2": "uyğun olanı biz tapaq.",
  "rv.blurb": "Üç sahəni doldurun, WhatsApp-ı hazır mesajınızla açırıq. Türk, ingilis, azərbaycan və ya polyak dilində yazın — adətən bir saat ərzində cavab veririk.",
  "rv.benefit.1": "Yalnız yoxlanılmış elanlar",
  "rv.benefit.2": "Əvvəlcədən vasitəçi haqqı yoxdur",
  "rv.benefit.3": "Sənəd köməyi daxildir",
  "rv.f.name": "Adınız (istəyə bağlı)",
  "rv.f.name.ph": "məs. Leyla",
  "rv.f.type": "Mənzil növü",
  "rv.f.type.ph": "Növ seçin",
  "rv.f.district": "Rayon (bir və ya bir neçə)",
  "rv.f.district.ph": "Rayon seçin",
  "rv.f.district.summary": "rayon seçildi",
  "rv.f.budget": "Büdcə (PLN / ay)",
  "rv.f.budget.ph": "məs. 3500",
  "rv.f.date": "Köçmə tarixi (istəyə bağlı)",
  "rv.f.date.ph": "Tarix seçin",
  "rv.submit": "WhatsApp ilə göndər",
  "rv.no_store": "Heç bir form məlumatı saxlanılmır — sorğunuz birbaşa WhatsApp-a göndərilir.",
  "rv.err": "Zəhmət olmasa ən azı bir rayon, mənzil növü və büdcənizi daxil edin.",
  "rv.opening": "WhatsApp sorğunuzla açılır…",
  "rv.msg.hi": "Salam!",
  "rv.msg.hi_name": "Salam, mən {name}.",
  "rv.msg.intro": "Unity Real Estate-dən baxış istəmək istəyirəm:",
  "rv.msg.district": "Rayon",
  "rv.msg.districts": "Rayonlar",
  "rv.msg.type": "Mənzil növü",
  "rv.msg.budget": "Büdcə",
  "rv.msg.move_in": "Köçmə",
  "rv.msg.flexible": "Çevik",
  "rv.msg.outro": "Mövcud variantları mənimlə paylaşa bilərsiniz? Təşəkkürlər!",
  "type.room": "Otaq (paylaşılan mənzildə)",
  "type.studio": "Studiya mənzil",
  "type.flat-1-2": "1–2 otaqlı mənzil",
  "type.flat-3plus": "3+ otaqlı mənzil",
  "type.house": "Fərdi ev",
  "district.any": "Fərq etməz / Əmin deyiləm",
  "srv.eyebrow": "Nə edirik",
  "srv.title.1": "Əvvəldən sona köçmə,",
  "srv.title.2": "qayğı ilə idarə olunur.",
  "srv.blurb": "Köçməyinizə öz köçməyimiz kimi yanaşan kiçik və fədakar komanda. Vasitəçi yoxdur, gizli ödəniş yoxdur, dil maneəsi yoxdur.",
  "srv.search.title": "Mənzil, otaq və ev axtarışı",
  "srv.search.desc": "Varşavada seçilmiş elanlar — paylaşılan otaqlardan ailə mənzillərinə qədər. Sizi düzgün ev sahibi, rayon və büdcə ilə uyğunlaşdırırıq.",
  "srv.search.points": ["Studiya · 1–4 otaqlı", "Qısa və uzunmüddətli", "Ev heyvanlarına uyğun"],
  "srv.docs.title": "Sənəd dəstəyi",
  "srv.docs.desc": "PESEL, qeydiyyat və icarə müqaviləsinin tərcüməsi — sənəd işləri bizdən, siz yerləşməyə fokuslanın.",
  "srv.docs.points": ["PESEL", "Müqavilə tərcüməsi", "Qeydiyyat"],
  "srv.view.title": "Baxış və danışıqlar",
  "srv.view.desc": "Sizinlə (və ya sizin yerinizə) mənzilə baxırıq, kirayə qiymətini danışırıq və müqavilənin sizi də qoruduğuna əmin oluruq.",
  "srv.view.points": ["Üzbəüz", "Virtual tur", "Danışıqlar"],
  "srv.lang.title": "Öz dilinizdə",
  "srv.lang.desc": "Türk, ingilis, azərbaycan və polyak dilləri — hər görüşdə, zəngdə və imza anında sizin səsiniz bizik.",
  "srv.cta_about": "Salam! Bu xidmət haqqında daha çox məlumat istəyirəm: {title}",
  "proc.eyebrow": "Necə işləyir",
  "proc.title.1": "İlk mesajdan",
  "proc.title.2": "əlinizdəki açara qədər.",
  "proc.s1.t": "Nə istədiyinizi deyin",
  "proc.s1.b": "Büdcə, rayon, köçmə tarixi. Öz dilinizdə qısa WhatsApp mesajı kifayətdir.",
  "proc.s2.t": "Siyahı hazırlayır, göstəririk",
  "proc.s2.b": "Real, yoxlanılmış variantlardan qısa siyahı təqdim edirik — saxta elan yoxdur, vasitəçi yoxdur. Üzbəüz və ya virtual tur.",
  "proc.s3.t": "Sənədlər qaydasında",
  "proc.s3.b": "İcarə müqaviləsini tərcümə edir, hər maddəni izah edirik; PESEL və qeydiyyatı sizinlə birlikdə həll edirik.",
  "proc.s4.t": "Köçün, yerləşin",
  "proc.s4.b": "Açarlar sizdədir. İlk həftələrdə kommunal xidmətlər, internet və lazım olan hər şey üçün yenə yanınızdayıq.",
  "pri.eyebrow": "Qiymətlər",
  "pri.title.1": "Aydın paketlər,",
  "pri.title.2": "fərdi qiymət təklifi.",
  "pri.blurb": "Hər köçmə fərqlidir — büdcə, müddət, dil və sənəd işləri son qiyməti formalaşdırır. Sizə uyğun paketi seçin, bir saat ərzində WhatsApp-da şəffaf qiymət təklifi göndərək.",
  "pri.cta": "Fərdi təklif al",
  "pri.best": "Ən çox seçilən",
  "pri.included": "Daxildir",
  "pri.not_included": "Daxil deyil",
  "pri.guarantees": "Gizli ödəniş yoxdur · İşə başlamazdan əvvəl şəffaf təklif · İlk görüş həmişə pulsuzdur",
  "pri.t1.name": "Mənzil axtarışı",
  "pri.t1.tag": "Düzgün mənzili tapaq — qaçhaqaç bizdən.",
  "pri.t1.inc": ["Büdcə və rayon məsləhəti", "Yoxlanılmış qısa elan siyahısı", "Üzbəüz və ya virtual tur", "Kirayə və depozit danışıqları", "Təhvil və açarların alınması"],
  "pri.t1.no": ["Sənəd xidmətləri", "Köçdən sonra dəstək"],
  "pri.t1.msg": "Salam! Mənzil axtarışı xidmətiniz üçün təklif almaq istəyirəm.",
  "pri.t2.name": "Axtarış + Sənədlər",
  "pri.t2.tag": "Varşavaya yeni gələnlərin ən çox seçimi.",
  "pri.t2.inc": ["Mənzil axtarışı paketindəki hər şey", "İcarə müqaviləsinin tərcüməsi və maddə-maddə yoxlanışı", "PESEL müraciətinə dəstək", "Qeydiyyat (meldunek) köməyi", "Bank hesabı və internet quraşdırılmasında bələdçilik"],
  "pri.t2.no": ["Yaşayış / viza prosedurları"],
  "pri.t2.msg": "Salam! Axtarış + Sənədlər paketi üçün təklif almaq istəyirəm.",
  "pri.t3.name": "Tam köçmə",
  "pri.t3.tag": "Hər şeyi biz həll edirik, siz sadəcə gəlin.",
  "pri.t3.inc": ["Axtarış + Sənədlər paketindəki hər şey", "Gəliş günü hava limanında qarşılama", "Abunəliklərin təhvili və müqavilələri", "Yaşayış kartı görüşü və müşayiət", "Köçdən sonra 30 gün sorğu əsasında dəstək"],
  "pri.t3.no": [],
  "pri.t3.msg": "Salam! Tam köçmə paketi üçün təklif almaq istəyirəm.",
  "why.eyebrow": "Niyə Unity",
  "why.title.1": "Varşavanı ilk gündən",
  "why.title.2": "eviniz kimi",
  "why.title.3": "hiss etdiririk.",
  "why.blurb": "Yeni ölkəyə köçmək kifayət qədər streslidir. Sənəd işlərini, mənzil axtarışını və danışıqları biz öz üzərimizə götürürük; siz bürokratiya ilə mübarizəyə deyil, yaşamağa gəlin.",
  "why.langs": "Dillər",
  "why.r1.t": "Əvvəlcə yeni gələnlər",
  "why.r1.x": "Varşavaya köçənlər üçün yaradılmışıq — yeni gələnləri çətinə salan tələləri və sənədləri bilirik.",
  "why.r2.t": "Gizli ödəniş yoxdur",
  "why.r2.x": "Əvvəlcədən aydın razılaşdırılmış şəffaf qiymət. İmza zamanı heç bir sürpriz yoxdur.",
  "why.r3.t": "Fərdi xidmət",
  "why.r3.x": "İlk mesajdan açarı aldığınız günə — və sonrasına — qədər bir əlaqə şəxsi.",
  "why.r4.t": "Yalnız yoxlanılmış elanlar",
  "why.r4.x": "Mənzillərə özümüz baxır və yoxlayırıq. Saxta elan və təkrar qeyd yoxdur.",
  "why.cta": "Köçməyinizə bizimlə başlayın",
  "tst.eyebrow": "Müştəri rəyləri",
  "tst.title.1": "300+ ailəyə kömək etdik",
  "tst.title.2": "5 fərqli ölkədən.",
  "tst.1.q": "İlk gündən mənimlə türkcə danışdılar. 5 günə Mokotówda gözəl mənzil tapdılar və PESEL-imi həll etdilər. Onlar olmasaydı, itib-batardım.",
  "tst.1.name": "Ayşe K.",
  "tst.1.from": "İstanbul → Varşava",
  "tst.2.q": "Dürüst, sürətli və mənə təklif olunan kirayədən xeyli yaxşısını danışdılar. İnterneti qurmağa və urząd-da qeydiyyata da kömək etdilər. Mütləq tövsiyə edirəm.",
  "tst.2.name": "Rəşad M.",
  "tst.2.from": "Bakı → Varşava",
  "tst.3.q": "İngilisdilli biri kimi polyak icarə müqavilələrindən çəkinirdim. Hər maddəni tərcümə etdilər və ədalətsiz bir şey imzalamadığıma əmin oldular.",
  "tst.3.name": "Emma P.",
  "tst.3.from": "London → Varşava",
  "faq.eyebrow": "Suallar",
  "faq.title.1": "Varşavaya köçmək —",
  "faq.title.2": "maraqlandığınız hər şey.",
  "faq.blurb": "Hər yeni gələnin depozit, PESEL, kommunal ödənişlər və kirayəçi hüquqları haqqında suallarına dürüst cavablar. Hələ də əmin deyilsiniz? Türk, ingilis, azərbaycan və ya polyak dilində yazın.",
  "faq.cta": "WhatsApp-da soruşun",
  "faq.cta.msg": "Salam! Varşavada kirayə haqqında sualım var.",
  "faq.q1": "PESEL nədir və kirayə üçün lazımdırmı?",
  "faq.a1": "PESEL Polşanın milli identifikasiya nömrəsidir. İcarə müqaviləsi imzalamaq üçün PESEL mütləq deyil, lakin həkimə yazılmaq, bank hesabı açmaq, uzunmüddətli iş müqaviləsi və vergilər üçün demək olar ki, hər yerdə tələb olunur. Köçmə xidmətimizin bir hissəsi kimi yerli Urząd Dzielnicy-də PESEL (CUDZOZIEMIEC növü) müraciətinizdə yanınızdayıq.",
  "faq.q2": "Nə qədər depozit ödəməliyəm?",
  "faq.a2": "Varşavada standart depozit (kaucja) 1 aylıq kirayədir; lüks mənzillərdə və ya çox qısamüddətli kirayələrdə 2 ay ola bilər. İlk ayın kirayəsi də əvvəlcədən ödənilir. İmzalamazdan əvvəl depozit şərtlərinin müqavilədə aydın yazıldığına əmin oluruq.",
  "faq.q3": "Vasitəçi haqqını mən, yoxsa ev sahibi ödəyir?",
  "faq.a3": "Unity Real Estate əvvəlcədən razılaşdırılmış, şəffaf haqq alır — gizli komissiya yoxdur. Axtarışa başlamazdan əvvəl, varsa, nə qədər və nə vaxt ödəyəcəyinizi aydın deyirik. Ev sahibi vasitəçiyə ödəyirsə, siz bizə heç nə ödəmirsiniz.",
  "faq.q4": "Varşavada mənzil tapmaq nə qədər çəkir?",
  "faq.a4": "İlk WhatsApp mesajından köçməyə adətən 3–10 gün. Otaqlar və studiyalar daha tez tutulur. Mokotów, Śródmieście və ya Wilanówda xüsusi istəkləri olan ailə mənzilləri 2–3 həftə çəkə bilər.",
  "faq.q5": "Polşa iş müqaviləm olmadan və ya hələ gəlməmişkən kirayə edə bilərəmmi?",
  "faq.a5": "Bəli. Müştərilərimizin çoxu ilk icarəsini Varşavaya gəlməzdən əvvəl imzalayır. Ev sahibləri adətən gəlir sənədi, pasport və etibarlı istinad istəyir. Sənədlərinizi tərcümə edib təqdim etməyinizə kömək edirik.",
  "faq.q6": "Polşada kirayəçi kimi hüquqlarım nələrdir?",
  "faq.a6": "Polşa icarə qanunu kirayəçini güclü qoruyur. Kirayə özbaşına artırıla bilməz, ev sahibi xəbərsiz daxil ola bilməz və depozit çıxışdan sonra 1 ay ərzində — sənədləşdirilmiş zərərlər çıxılmaqla — qaytarılmalıdır. Müqavilənizdəki hər maddəni imzalamazdan əvvəl yoxlayırıq.",
  "faq.q7": "Kommunal xərcləri (su, işıq, qaz, internet) kim ödəyir?",
  "faq.a7": "Adətən kirayəyə idarəetmə haqqı (czynsz administracyjny — bina xidməti, bəzən su/istilik) daxildir; işıq və interneti ayrıca ödəyirsiniz. İmzalamazdan əvvəl nəyin daxil olduğunu mütləq yoxlayırıq.",
  "faq.q8": "İcarəmi təhvil alacaq yeni kirayəçi tapmağa kömək edirsiniz?",
  "faq.a8": "Bəli — bu, ən çox aldığımız sorğulardan biridir. Mənzili elan edir, namizədləri seçir, baxışları öz dilinizdə idarə edir və ev sahibinizlə təhvil prosesini əlaqələndiririk ki, depozitiniz təhlükəsiz olsun.",
  "faq.q9": "Artıq Varşavada yaşayıram, amma mənzil dəyişmək istəyirəm — yenə kömək edirsiniz?",
  "faq.a9": "Əlbəttə. Bazarı, bina idarəçilərini və rayonlar üzrə ədalətli kirayə qiymətlərini bilirik; tək axtarmaqdan daha tez daha yaxşı mənzil tapıb, mövcud icarənizdən problemsiz çıxmağınıza kömək edirik.",
  "faq.q10": "Yalnız türk və azərbaycanlı müştərilərə kömək edirsiniz?",
  "faq.a10": "Xeyr — Varşavaya köçən hər kəsə kömək edirik. Türk, ingilis, azərbaycan və polyak dillərində sərbəst danışırıq. Müştərilərimizin çoxu türk və azərbaycanlı olsa da, 5 fərqli ölkədən gələn insanlarla işləyirik.",
  "ctc.eyebrow": "Danışaq",
  "ctc.title.1": "Öz",
  "ctc.title.2": "Varşavanızı tapmağa hazırsınız?",
  "ctc.blurb": "Bizə türk, ingilis, azərbaycan və ya polyak dilində WhatsApp mesajı göndərin. Adətən bir saat ərzində cavab veririk.",
  "ctc.cta_wa": "WhatsApp-da yaz",
  "ctc.cta_call": "Zəng et {phone}",
  "ctc.phone": "Telefon / WhatsApp",
  "ctc.based": "Ünvan",
  "ctc.based_val": "Varşava, Polşa",
  "ctc.reply": "Cavab müddəti",
  "ctc.reply_val": "Adətən 1 saat ərzində",
  "ftr.tag": "Varşavaya gələnlərə ev tapıb yerləşməyə kömək edirik — qayğı ilə, öz dilinizdə.",
  "ftr.explore": "Kəşf et",
  "ftr.contact": "Əlaqə saxlayın",
  "ftr.warsaw": "Varşava, Polşa",
  "ftr.rights": "Bütün hüquqlar qorunur.",
  "ftr.chat": "WhatsApp söhbəti",
  "fwa.tip.q": "Varşavada mənzil lazımdır?",
  "fwa.tip.a": "Öz dilinizdə soruşun.",
  "fwa.aria": "WhatsApp-da yaz",
  "tst.rating.score": "4.9 / 5",
  "tst.rating.sub": "87 WhatsApp və üzbəüz rəy əsasında",
  "tst.verified": "WhatsApp ilə təsdiqlənib",
  "tst.4.q": "Bakıdan bir kəlmə də polyakca bilmədən gəldim. Məni hava limanında qarşıladılar, elə həmin həftə baxışlara apardılar və müqaviləni sətir-sətir tərcümə etdilər.",
  "tst.4.name": "Rəşad A.",
  "tst.4.from": "Bakı → Mokotów",
  "wa.default": "Salam! Varşavada mənzil tapmaq üçün köməyə ehtiyacım var.",
};
